import { render, staticRenderFns } from "./detail-graph.vue?vue&type=template&id=3d5c0ae0&scoped=true"
import script from "./detail-graph.vue?vue&type=script&lang=js"
export * from "./detail-graph.vue?vue&type=script&lang=js"
import style0 from "./detail-graph.vue?vue&type=style&index=0&id=3d5c0ae0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d5c0ae0",
  null
  
)

export default component.exports